import React, { useEffect } from 'react';
import vosIcon from '../assects/VAV School Logo icon solid BG.svg';

interface Props {
  onDone: () => void;
}

const SplashScreen: React.FC<Props> = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(0.85); }
          50% { opacity: 1; transform: scale(1); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes logoReveal {
          from { opacity: 0; transform: scale(0.88); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>

      <div style={{
        position: 'fixed',
        inset: 0,
        background: '#3b1f52',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          animation: 'logoReveal 0.6s cubic-bezier(0.22,1,0.36,1) both',
        }}>
          <img
            src={vosIcon}
            alt="VAV School"
            style={{
              width: 130,
              height: 130,
              objectFit: 'contain',
            }}
          />
        </div>

        {/* Loading dots */}
        <div style={{
          position: 'absolute',
          bottom: 56,
          display: 'flex',
          gap: 8,
          animation: 'fadeIn 0.5s ease 1s both',
        }}>
          {[0, 1, 2].map(i => (
            <div
              key={i}
              style={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.45)',
                animation: `pulse 1.4s ease ${i * 0.22}s infinite`,
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SplashScreen;